import { ArrowUpRight } from 'lucide-react';
import { LANDING } from '@/constants/testIds';
import { CATEGORIES } from '@/data/business';
import { useReveal } from '@/hooks/useReveal';

export const Categories = () => {
    const [ref, visible] = useReveal();

    return (
        <section
            id="categories"
            data-testid={LANDING.categories}
            ref={ref}
            className="relative py-20 sm:py-28 border-t border-white/5"
        >
            <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
                <div className={`reveal ${visible ? 'in-view' : ''} flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10 sm:mb-14`}>
                    <div>
                        <span className="section-label">03 / Produits</span>
                        <h2 className="mt-4 font-display uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9] text-white">
                            Tout l'EPI <br />
                            <span className="text-outline-yellow">au même endroit</span>
                        </h2>
                    </div>
                    <p className="max-w-md text-base sm:text-lg text-white leading-relaxed">
                        Femmes, hommes et accessoires : MANU VET équipe vos équipes de la tête aux pieds, en boutique à Aulnay-sous-Bois.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                    {CATEGORIES.map((cat, i) => (
                        <a
                            key={cat.slug}
                            href="#contact"
                            data-testid={`${LANDING.categoryCard}-${cat.slug}`}
                            className={`group relative overflow-hidden corner-cut bg-[#121212] border border-white/10 hover:border-[#FFD500]/60 transition-all duration-500 ${
                                visible ? 'in-view reveal' : 'reveal'
                            }`}
                            style={{ animationDelay: `${0.1 + i * 0.08}s`, minHeight: '380px' }}
                        >
                            <div className="absolute inset-0">
                                <img
                                    src={cat.image}
                                    alt={`${cat.title} – Vêtements de travail`}
                                    className="h-full w-full object-cover opacity-50 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                                    loading="lazy"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
                            </div>

                            <div className="relative h-full flex flex-col justify-between p-5 sm:p-6">
                                <div className="flex items-start justify-between">
                                    <span className="font-display text-xs uppercase tracking-[0.25em] text-[#FFD500]">
                                        — {cat.kicker}
                                    </span>
                                    <ArrowUpRight className="h-5 w-5 text-white/55 group-hover:text-[#FFD500] group-hover:rotate-45 transition-all" />
                                </div>

                                <div>
                                    <h3 className="font-display uppercase text-3xl sm:text-4xl text-white leading-none">
                                        {cat.title}
                                    </h3>
                                    <p className="mt-3 text-xs sm:text-sm text-white leading-relaxed">
                                        {cat.description}
                                    </p>
                                    <div className="mt-4 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-white/55 group-hover:text-[#FFD500] transition-colors">
                                        <span>Voir en boutique</span>
                                        <span className="h-px w-6 bg-current" />
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};
